/* eslint-disable no-undef */
// @ts-nocheck

export const callGAanalyitcs = (eventName, data) => {
  if (eventName == 'trackEvents') {
    createGAData(data);
  }
};

const createGAData = (data) => {
  let credentials = {
    ga: true,
    type: 'trackEvents',
    step: data.step,
    stepName: data.stepName,
    data: {
      ...data.data.trackingDataGA,
      moid: data.data.orderName ? data.data.orderName : data.data.moid,
      coupon: data.data.trackingDataGA?.coupon || '',
      shipping: data.data.shippingCharge,
      orderType: data.data.paymentMethod,
      eventID: `Gokwik ${data.random}`,
    },
  };
  fireGaCall(credentials);
};

const fireGaCall = (data) => {
  switch (data.step) {
    case 1:
      ga('require', 'ec');
      ga('ec:setAction', 'checkout', { step: 1 });
      data.data?.contents_sku.forEach((element) => ga('ec:addProduct', element));
      // ga("ec:addProduct", { id: 39613790486690, name: "Sample Item 2", quantity: 1, price: "1.00", variant: "", currency: "INR"});
      ga('send', 'pageview', { page: '/checkout/contact_information' });
      ga('send', 'event', {
        eventCategory: 'All',
        eventAction: 'Viewed Checkout - Contact Information Page',
        eventLabel: undefined,
        nonInteraction: true,
      });
      ga('send', 'event', {
        eventCategory: 'EnhancedEcommerce',
        eventAction: 'Started Order',
        eventLabel: 'gokwik_checkout_initiated',
        nonInteraction: true,
      });
      break;
    case 2:
      ga('ec:setAction', 'checkout', { step: 2 });
      data.data?.contents_sku.forEach((element) => ga('ec:addProduct', element));
      ga('send', 'pageview', { page: '/checkout/shipping' });
      ga('send', 'event', {
        eventAction: 'Viewed Checkout - Shipping Page',
        eventCategory: 'All',
        eventLabel: undefined,
        eventValue: 0,
        nonInteraction: true,
      });
      ga('ec:setAction', 'checkout', {
        id: data.data.moid,
        revenue: +data.data.gaTotalAmount,
        tax: '0.00',
        shipping: data.data.shipping,
        coupon: data.data.coupon,
      });
      break;
    case 3:
      ga('ec:setAction', 'checkout', { step: 3 });
      data?.data.contents_sku.forEach((element) => ga('ec:addProduct', element));
      ga('send', 'pageview', { page: '/checkout/payment' });
      ga('send', 'event', {
        eventAction: 'Viewed Checkout - Payment Page',
        eventCategory: 'All',
        eventLabel: undefined,
        eventValue: 0,
        nonInteraction: true,
      });

      ga('ec:setAction', 'checkout', {
        id: data.data.moid,
        revenue: +data.data.gaTotalAmount,
        tax: '0.00',
        shipping: data.data.shipping,
        coupon: data.data.coupon,
      });
      // ga('send', 'event', {
      //   eventCategory: 'EnhancedEcommerce',
      //   eventAction: 'Completed Order',
      //   eventLabel: 'gokwik_purchase',
      //   nonInteraction: true,
      // });
      break;
    case 4:
      ga('ec:setAction', 'purchase', { step: 4 });
      ga('send', 'event', {
        eventAction: 'Viewed Checkout - Receipt Page',
        eventCategory: 'All',
        eventLabel: undefined,
        eventValue: 0,
        nonInteraction: true,
      });
      ga('send', 'pageview', { page: '/checkout/thank_you' });
      data?.data.contents_sku.forEach((element) => ga('ec:addProduct', element));
      ga('ec:setAction', 'purchase', {
        id: data.data.moid,
        revenue: +data.data.gaTotalAmount,
        tax: '0.00',
        shipping: data.data.shipping,
        coupon: data.data.coupon,
      });
      ga('send', 'event', {
        eventCategory: 'EnhancedEcommerce',
        eventAction: 'Completed Order',
        eventLabel: 'gokwik_purchase',
        nonInteraction: true,
      });
      break;
    case 5:
      ga('send', 'pageview', { page: '/gk/adl' });
      break;
    default:
      return;
  }
};
